import React from 'react';
import { Link } from 'react-router-dom';
import { BrandLogo } from '../brand/BrandLogo';

export function AuthBrandHeader() {
  return (
    <div className="mb-8 text-center">
      <Link to="/" className="inline-flex items-center gap-3">
        <BrandLogo size="md" />
        <div className="text-left">
          <p className="text-xs font-medium uppercase tracking-widest text-brand-gold">
            Mungkorn
          </p>
          <h1 className="text-2xl font-bold text-brand-red">MUNGKORN LOTTO</h1>
        </div>
      </Link>
    </div>
  );
}
